import { useMutation } from "@tanstack/vue-query";
import { request } from "@/shared/http/client";

/**
 * O polegar na resposta do painel.
 *
 * ── POR QUE APONTA PARA O TURNO ───────────────────────────────────────────
 *
 * Porque o turno é a coisa que tem um porquê: o prompt que ele recebeu, os fatos
 * que recuperou, as ferramentas que rodou e o modelo que respondeu — tudo o que
 * alguém que escreveu "isso está errado" vai querer olhar. A consequência é
 * deliberada: um turno pode chegar como três bolhas, e avaliar qualquer uma
 * avalia o turno uma vez.
 *
 * ── POR QUE AQUI E NÃO NA INBOX ───────────────────────────────────────────
 *
 * `POST /v3/agents/turns/:id/rating` é a MESMA rota que a inbox usa; o que não
 * viaja é o código, porque uma feature nunca importa outra
 * (`.dependency-cruiser.cjs`, `no-cross-feature`). A diferença que importa está
 * em como cada lado ACHA o turno: a inbox casa bolha e turno por horário, porque
 * a mensagem do cliente não carrega o id; aqui o `frame done` diz qual foi, e
 * adivinhar seria escolher a via pior tendo a boa.
 *
 * Não invalida nada: uma avaliação é uma opinião sobre o que aconteceu, não algo
 * mais acontecendo. Nenhum número da tela de uso se mexe, e a bolha guarda o que
 * foi dito na própria lista que já está na tela.
 */
export function useRateTurn() {
	return useMutation({
		mutationFn: (input: { turnId: string; rating: 1 | -1; note?: string }) =>
			request<{ ok: true }>(`/v3/agents/turns/${input.turnId}/rating`, {
				method: "POST",
				body: { rating: input.rating, ...(input.note ? { note: input.note } : {}) },
			}),
	});
}
